<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			width="95%"
			:max-width="1400"
			:min-width="1000"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
                <v-icon color="white" class="info-icon mr-2">mdi-list-box-outline</v-icon>
								<p class="mb-0 font-weight-bold text-primary title">Tabla de Costos Proyecto</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
					<v-tabs
						v-model="tab"
						class="custom-color-tabs"
						color="white"
						grow
						height="40">
						<v-tab>Tabla General de Costos</v-tab>
						<v-tab v-show="costsTable.project_tables && costsTable.project_tables.length">
							<div>
								<p class="mb-0">Anexos Tabla de Costos</p>
								<p class="mb-0" style="font-size: 10px;">(Adicionales)</p>
							</div>
						</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab" class="tab-item-custom" style="width: 100%; flex-grow: 1;min-height: 300px;">
						<v-tab-item eager>
							<GeneralTableCost
								:fromModal="true"
								:costs-table="costsTable"
								:contract="contract"
								:project="project"
								:colors="colors"
								:colorVars="colorVars"
								:uf-value="ufValue"
								:selectedUfValue="selectedUfValue"
								:currency="currency"
								:col-widths="colWidths"
								:can-show-reception-section="canShowReceptionSection"
								:cost_categories_config="cost_categories_config"
								:addStage="addStage"
								:addProject="addProject"
								:removeProject="removeProject"
								:onChangeSecondaryCostProject="onChangeSecondaryCostProject"
								:onChangeSecondaryCostProjectItem="onChangeSecondaryCostProjectItem"
								:updateStage="updateStage"
								:addReception="addReception"
								:removeReception="removeReception"
								:updateReception="updateReception"
								:addSpecialty="addSpecialty"
								:updateSpecialty="updateSpecialty"
								:updateSurfaceItems="updateSurfaceItems"
								:updateCostItems="updateCostItems"
							/>
						</v-tab-item>
						<v-tab-item eager v-show="costsTable.project_tables && costsTable.project_tables.length">
							<div v-for="(project_table, index) in sortedProjectTables" :key="'project_tables_main-' + index" class="my-2">
								<SecondaryTableCost
									:fromModal="true"
									:isLastItem="index === costsTable.project_tables.length -1"
									:selectedUfValue="selectedUfValue"
									:costs-table="project_table"
									:parent-costs-table="costsTable"
									:project="project"
									:colors="colors"
									:colorVars="colorVars"
									:uf-value="ufValue"
									:currency="currency"
									:col-widths="colWidths"
									:can-show-reception-section="canShowReceptionSection"
									:cost_categories_config="cost_categories_config"
								/>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import GeneralTableCost from '@/components/Views/Projects/TableCostParts/GeneralTableCost.vue'
import SecondaryTableCost from '@/components/Views/Projects/TableCostParts/SecondaryTableCost.vue'

export default {
  name: 'CostBreakdownMainTableModal',
  components: { GeneralTableCost, SecondaryTableCost },
	props: {
		costsTable: {
			type: Object,
			required: true
		},
		project: {
			type: Object,
			required: true
		},
		contract: {
			type: Object,
			required: false
		},
		colors: {
			type: Object,
			required: false
		},
    colorVars: {
      type: Array,
      default: () => []
    },
		ufValue: {
			type: Number,
			required: false
		},
		selectedUfValue: {
			type: Object,
			required: false
		},
		currency: {
      type: String,
      default: 'uf'
		},
		colWidths: {
			type: Array,
			required: false
		},
		canShowReceptionSection: {
			type: Boolean,
			required: false
		},
		cost_categories_config: {
			type: Array,
			required: false
		},
		addStage: {
			type: Function,
			required: false
		},
		addProject: {
			type: Function,
			required: false
		},
		removeProject: {
			type: Function,
			required: false
		},
		onChangeSecondaryCostProject: {
			type: Function,
			required: false
		},
		onChangeSecondaryCostProjectItem: {
			type: Function,
			required: false
		},
		updateStage: {
			type: Function,
			required: false
		},
		addReception: {
			type: Function,
			required: false
		},
		removeReception: {
			type: Function,
			required: false
		},
		updateReception: {
			type: Function,
			required: false
		},
		addSpecialty: {
			type: Function,
			required: false
		},
		updateSpecialty: {
			type: Function,
			required: false
		},
		updateSurfaceItems: {
			type: Function,
			required: false
		},
		updateCostItems: {
			type: Function,
			required: false
		}
	},
  computed: {
		sortedProjectTables() {
			return this.costsTable.project_tables
			// if (!this.costsTable.project_tables || !this.costsTable.project_tables.length) return null;
			// const workingId = this.working_cost_table.id;
			// return [...this.costsTable.project_tables].sort((a, b) => {
			// 		if (a.id === workingId) return -1;
			// 		if (b.id === workingId) return 1;
			// 		return 0;
			// });
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	data() {
		return {
			indexModal: + new Date(),
			tab: 0,
		};
	},
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		if(this.$route.hash == '#general' || !this.$route.hash || !this.costsTable.project_tables || !this.costsTable.project_tables.length){
			this.tab = 0;
		}
		else{
			this.tab = 1;
		}
  },
  methods: {
    closeModal(){
      this.$store.commit('costbreakdown/setCostBreakdownMainTableModal', false)
    }
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }

	.custom-color-tabs .v-tab{
		font-size: 12px;
	}
	.custom-color-tabs .v-tab.v-tab--active {
		background-color: #FF120B;
		color: #FFFFFF;
	}
	.custom-color-tabs .v-tab:not(.v-tab--active) {
		background-color: white;
		color: #000000!important;
	}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>